<template>
  <div class="container-fluid">
    <div class="row mb-3 align-items-center">
      <div class="col">
        <h4 class="mb-1">Zonas de alta demanda</h4>
        <p class="text-muted mb-0">
          Polígonos con bono por horario (Chile · Puerto Montt / Los Lagos). Si la hora de fin es menor que la de inicio, la zona cruza medianoche (ej. 22:00 → 06:00).
        </p>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary" @click="goCreate">
          Agregar zona
        </button>
      </div>
    </div>

    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
    <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5 text-muted">Cargando zonas…</div>
        <div v-else class="table-responsive">
          <table class="table table-hover align-middle">
            <thead>
              <tr>
                <th>Zona</th>
                <th>Bono</th>
                <th>Horario</th>
                <th>Estado</th>
                <th class="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="zone in zones" :key="zone.id">
                <td>
                  <div class="d-flex align-items-center">
                    <span
                      class="zone-color-swatch mr-2"
                      :style="{ background: zone.color || '#1E3A8A' }"
                    />
                    <strong>{{ zone.name }}</strong>
                  </div>
                </td>
                <td>
                  <span v-if="zone.bonusType === 'cantidad'">
                    ${{ formatAmount(zone.bonusValue) }} CLP
                  </span>
                  <span v-else>{{ formatAmount(zone.bonusValue) }}%</span>
                </td>
                <td>
                  <div>{{ zone.startTime }} → {{ zone.endTime }}</div>
                  <small v-if="zone.crossesMidnight" class="text-warning">
                    Cruza medianoche (+1 día)
                  </small>
                </td>
                <td>
                  <span :class="zone.isActive ? 'badge badge-success' : 'badge badge-secondary'">
                    {{ zone.isActive ? 'Activa' : 'Inactiva' }}
                  </span>
                </td>
                <td class="text-right text-nowrap">
                  <button class="btn btn-sm btn-outline-primary mr-1" @click="goEdit(zone)">
                    Editar
                  </button>
                  <button class="btn btn-sm btn-outline-danger" @click="confirmDelete(zone)">
                    Eliminar
                  </button>
                </td>
              </tr>
              <tr v-if="!zones.length">
                <td colspan="5" class="text-center text-muted py-4">
                  No hay zonas configuradas.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { deleteZone, fetchZones } from '@/services/zonesApi';

export default {
  name: 'ZonasPage',
  data() {
    return {
      loading: true,
      zones: [],
      errorMessage: '',
      successMessage: '',
    };
  },
  created() {
    if (this.$route.query.saved) {
      this.successMessage = 'Zona guardada correctamente';
    }
    this.load();
  },
  methods: {
    formatAmount(value) {
      return Number(value || 0).toLocaleString('es-CL');
    },
    async load() {
      this.loading = true;
      this.errorMessage = '';
      try {
        this.zones = await fetchZones();
      } catch (e) {
        this.errorMessage = e.message || 'Error al cargar zonas';
      } finally {
        this.loading = false;
      }
    },
    goCreate() {
      this.$router.push({ name: 'zona-nueva' });
    },
    goEdit(zone) {
      this.$router.push({ name: 'zona-editar', params: { id: zone.id } });
    },
    async confirmDelete(zone) {
      const result = await Swal.fire({
        title: '¿Eliminar zona?',
        text: zone.name,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (!result.isConfirmed) return;
      try {
        await deleteZone(zone.id);
        this.successMessage = 'Zona eliminada';
        await this.load();
      } catch (e) {
        this.errorMessage = e.message || 'Error al eliminar';
      }
    },
  },
};
</script>

<style scoped>
.zone-color-swatch {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  display: inline-block;
  flex-shrink: 0;
}
</style>
